"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendRecordingsToMck = exports.getRateCard = exports.getCapiReasonOptions = exports.getCapiReason = exports.getLatestProjectDetails = exports.deleteFile = exports.getCorrespondenceById = exports.loadCorrespondence = exports.upload = exports.reply = exports.updateInvoiceStatus = exports.checkInvoice = exports.createInvoice = exports.provideAvailabilities = exports.submitExpert = exports.fixCallState = exports.getCallInfo = exports.syncStatus = exports.rejectExpert = exports.completeCall = exports.ongoingCall = exports.cancelCall = exports.createFollowUpEpl = exports.getCallByEplId = exports.getCallsByEplIds = exports.getWorkstream = exports.getProject = void 0;
var tslib_1 = require("tslib");
// @ts-nocheck
var api_1 = require("./api");
var axios_1 = tslib_1.__importDefault(require("axios"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var SIXTY_SECONDS = 60000;
var axiosInstance = axios_1.default.create({
    timeout: SIXTY_SECONDS,
    baseURL: process.env.REACT_APP_CAPI_SERVICE_URL,
    responseType: 'json',
});
axiosInstance.interceptors.request.use(function (request) {
    request.headers.Authorization = tokenStorage_1.default.get();
    return request;
});
axiosInstance.interceptors.response.use(function (response) {
    if (response.data === undefined)
        return response;
    return response.data;
}, function (error) {
    return Promise.reject(error);
});
function getProject(projectId) {
    return axiosInstance({
        method: 'get',
        url: "/check?p=".concat(projectId),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getProject = getProject;
function getWorkstream(segmentId) {
    return axiosInstance({
        method: 'get',
        url: "/check?w=".concat(segmentId),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getWorkstream = getWorkstream;
function getCallsByEplIds(eplIds) {
    return axiosInstance({
        method: 'post',
        url: "/calls/by/epl-ids",
        data: eplIds,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getCallsByEplIds = getCallsByEplIds;
function getCallByEplId(eplId) {
    return axiosInstance({
        method: 'get',
        url: "/calls/by/epl/".concat(eplId),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getCallByEplId = getCallByEplId;
function createFollowUpEpl(eplId, deliveredByEmployeeId) {
    return axiosInstance({
        method: 'post',
        url: "/calls/follow-up",
        data: {
            eplId: eplId,
            deliveredByEmployeeId: deliveredByEmployeeId,
        },
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.createFollowUpEpl = createFollowUpEpl;
function cancelCall(eplId, reason) {
    return axiosInstance({
        method: 'POST',
        url: "/calls/cancel",
        data: { eplId: eplId, reason: reason },
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.cancelCall = cancelCall;
function ongoingCall(eplId) {
    return axiosInstance({
        method: 'POST',
        url: "/calls/ongoing",
        data: { eplId: eplId },
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.ongoingCall = ongoingCall;
function completeCall(eplId, actualDuration) {
    return axiosInstance({
        method: 'POST',
        url: "/calls/complete",
        data: { eplId: eplId, actualDuration: actualDuration },
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.completeCall = completeCall;
function rejectExpert(data) {
    return axiosInstance({
        method: 'post',
        url: "/experts/reject",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.rejectExpert = rejectExpert;
function syncStatus(data) {
    return axiosInstance({
        method: 'post',
        url: "/calls/sync/status",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.syncStatus = syncStatus;
var getCallInfo = function (_a) {
    var eplId = _a.eplId;
    return axiosInstance({
        method: 'get',
        url: "/calls/".concat(eplId, "/info"),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.getCallInfo = getCallInfo;
var fixCallState = function (_a) {
    var eplId = _a.eplId;
    return axiosInstance({
        method: 'get',
        url: "/calls/".concat(eplId, "/fix"),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.fixCallState = fixCallState;
function submitExpert(data) {
    return axiosInstance({
        method: 'post',
        url: "/submit",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.submitExpert = submitExpert;
function provideAvailabilities(data) {
    return axiosInstance({
        method: 'post',
        url: "/calls/availability/provide",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.provideAvailabilities = provideAvailabilities;
function createInvoice(data) {
    return axiosInstance({
        method: 'post',
        url: "/create-platform-invoice",
        data: data,
    }).catch(api_1.errorHandler);
}
exports.createInvoice = createInvoice;
function checkInvoice(data) {
    return axiosInstance({
        method: 'post',
        url: "/invoice/check",
        data: data,
    })
        .then(api_1.extractData)
        .catch(function (error) {
        if (error.message === 'Request failed with status code 404') {
            console.error({ error: error });
            return;
        }
        (0, api_1.errorHandler)(error);
    });
}
exports.checkInvoice = checkInvoice;
function updateInvoiceStatus(data) {
    return axiosInstance({
        method: 'post',
        url: "/invoice/update-status",
        data: data,
    }).catch(api_1.errorHandler);
}
exports.updateInvoiceStatus = updateInvoiceStatus;
function reply(data) {
    return axiosInstance({
        method: 'post',
        url: "/reply",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.reply = reply;
function upload(data) {
    return axiosInstance({
        method: 'post',
        url: "/upload",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.upload = upload;
function loadCorrespondence(_a) {
    var projectId = _a.projectId, limit = _a.limit, offset = _a.offset;
    return axiosInstance({
        method: 'get',
        url: "/correspondence?p=".concat(projectId, "&offset=").concat(offset, "&limit=").concat(limit),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.loadCorrespondence = loadCorrespondence;
function getCorrespondenceById(id, type) {
    return axiosInstance({
        method: 'get',
        url: "/correspondenceDetails?id=".concat(id, "&type=").concat(type),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getCorrespondenceById = getCorrespondenceById;
function deleteFile(id) {
    return axiosInstance({
        method: 'get',
        url: "/deleteFile?f=".concat(id),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.deleteFile = deleteFile;
function getLatestProjectDetails(projectId) {
    return axiosInstance({
        method: 'get',
        url: "/get-latest-project-details/".concat(projectId),
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getLatestProjectDetails = getLatestProjectDetails;
/**
 * Remaps platform cancellation reasons to ENS acceptable reasons
 *
 * Keeps legacy platform saving the values as it was before.
 * Only needed for CAPI to comply with ENS requirements
 * ```
 * | Platform epl status comment              | CAPI equivalent                              |
 *  _________________________________________________________________________________________
 * | By client - Change of schedule           | engagement_team_requested_cancellation       |
 * | By expert - Change of schedule / backout | expert_no_longer_available_at_scheduled_time |
 * ```
 * @param {number} platformCommentId - corresponds to eplStatusCommentId
 */
function getCapiReason(platformCommentId) {
    var CAPI_REASONS = {
        7: 'engagement_team_requested_cancellation',
        8: 'expert_no_longer_available_at_scheduled_time', // Maps to eplStatusComment: 'By expert - Change of schedule / backout'
    };
    return CAPI_REASONS[platformCommentId] || null;
}
exports.getCapiReason = getCapiReason;
/**
 * @returns options array with ENS reasons to cancel the call
 */
function getCapiReasonOptions() {
    return [
        {
            id: 8,
            name: 'Expert no longer available at scheduled time',
        },
        {
            id: 7,
            name: 'Engagement team requested cancellation',
        },
    ];
}
exports.getCapiReasonOptions = getCapiReasonOptions;
function getRateCard() {
    return {
        multipliers: [1.0, 1.25, 1.5, 1.75, 2.0],
        regions: {
            Global: {
                1.0: 1102.0,
                1.25: 1377.0,
                1.5: 1653.0,
                1.75: 1928.0,
                2.0: 2203.0,
            },
            'China, India Domestic': {
                1.0: 714.0,
                1.25: 893.0,
                1.5: 1071.0,
                1.75: 1250.0,
                2.0: 1428.0,
            },
        },
    };
}
exports.getRateCard = getRateCard;
var sendRecordingsToMck = function (scheduleId) {
    return axiosInstance({
        method: 'POST',
        url: "/calls/recording",
        data: { scheduleId: scheduleId },
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.sendRecordingsToMck = sendRecordingsToMck;
var capi = {
    fixCallState: exports.fixCallState,
    getRateCard: getRateCard,
    getProject: getProject,
    getWorkstream: getWorkstream,
    getCallsByEplIds: getCallsByEplIds,
    getCallByEplId: getCallByEplId,
    getCallInfo: exports.getCallInfo,
    getCapiReason: getCapiReason,
    getCapiReasonOptions: getCapiReasonOptions,
    submitExpert: submitExpert,
    rejectExpert: rejectExpert,
    cancelCall: cancelCall,
    completeCall: completeCall,
    createFollowUpEpl: createFollowUpEpl,
    provideAvailabilities: provideAvailabilities,
    createInvoice: createInvoice,
    checkInvoice: checkInvoice,
    updateInvoiceStatus: updateInvoiceStatus,
    reply: reply,
    deleteFile: deleteFile,
    loadCorrespondence: loadCorrespondence,
    upload: upload,
    getCorrespondenceById: getCorrespondenceById,
    getLatestProjectDetails: getLatestProjectDetails,
    syncStatus: syncStatus,
    sendRecordingsToMck: exports.sendRecordingsToMck,
};
exports.default = capi;
